/**
 * @description: 花管理
 * @author: lyr
 */
<template>
<div class="flower-manage">
    <ul class="row list-tit" v-show="showIndex==1">
        <li class="col-md-3" v-for="menuItem in menu" :key="menuItem.id"><span class="col-md-10" @click="titClk(menuItem.name)">{{menuItem.name}}</span></li>
    </ul>
    
    <!-- 花类型 -->
    <div class="type-list" v-show="showIndex==2">
        <el-row>
            <div class="red-tip">注：显示顺序大的在显示端显示靠前</div>
            <div class="pull-right">
                <el-button type="primary" v-show="type_oper.add" @click="openTypePop">添加类型</el-button>
            </div>
        </el-row>
        <el-table
            class="type-table"
            v-loading="loading"
            element-loading-text="努力加载中，请稍后..."
            element-loading-background="rgba(0, 0, 0, 0.6)"
            :data="type_list">
            <el-table-column prop="listorder" label="显示顺序"></el-table-column>
            <el-table-column prop="name" label="商品类型"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <span class="text-blue" @click="editType(scope.row)" v-show="type_oper.edit">修改</span>
                    <span class="text-blue" @click="delType(scope.row.id)" v-show="type_oper.del">删除</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :page-size="GLOBAL.PAGESIZE"
            :current-page.sync="type_page"
            :total="type_total"
            @current-change="getTypeList">
        </el-pagination>
        <el-button @click="backIndex">返回</el-button>  
        <!-- 类型弹窗 -->
        <div class="type-pop" ref="type_pop">
            <el-form :model="type_pop_form" label-width="70px">
                <el-form-item label="显示顺序">
                    <el-input v-model="type_pop_form.listorder" placeholder="请输入显示顺序"></el-input>
                </el-form-item>
                <el-form-item label="类型名称">
                    <el-input v-model="type_pop_form.name" placeholder="请输入类型名称"></el-input>
                </el-form-item>
            </el-form>
        </div>
    </div>

    <!-- 花列表 -->
    <div class="flower-list" v-show="showIndex==3&&!showFlower">
        <el-form :inline="true" :model="flower_form">
            <el-form-item label="门店">
                <el-select v-model="flower_form.shop_id" filterable placeholder="请选择门店">
                    <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="类型">
                <el-select v-model="flower_form.type" filterable placeholder="请选择类型">
                    <el-option label="全部" value="0"></el-option>
                    <el-option v-for="item in type_list_for_select" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="flower_form.status" placeholder="请选择状态">
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="启用" value="1"></el-option>
                    <el-option label="禁用" value="-1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="名称">
                <el-input v-model="flower_form.name" placeholder="请输入花单名称"></el-input>
            </el-form-item>
            <div class="pull-right">
                <el-button type="primary" v-show="flower_oper.add" @click="onAddFlowerClick">新增</el-button>
                <el-button type="primary" @click="flowerQuery">查询</el-button>
            </div>
        </el-form>
        <el-table
            class="flower-table"
            v-loading="loading"
            element-loading-text="努力加载中，请稍后..."
            element-loading-background="rgba(0, 0, 0, 0.6)"
            :data="flower_list">
            <el-table-column prop="shop_name" label="门店"></el-table-column>
            <el-table-column prop="listorder" label="显示顺序"></el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="unit_name" label="单位"></el-table-column>
            <el-table-column prop="type_name" label="类型"></el-table-column>
            <el-table-column prop="discount_price" label="单价"></el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">{{scope.row.status=='1'?'启用':'禁用'}}</template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <span class="text-blue" @click="editFlower(scope.row)" v-show="flower_oper.edit">修改</span>
                    <span class="text-blue" @click="updateFlower(scope.row.id, '1')" v-show="flower_oper.update&&scope.row.status=='-1'">启用</span>
                    <span class="text-blue" @click="updateFlower(scope.row.id, '-1')" v-show="flower_oper.update&&scope.row.status=='1'">禁用</span>
                    <span class="text-blue"  @click="updateFlower(scope.row.id, '-2')" v-show="flower_oper.del">删除</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :page-size="GLOBAL.PAGESIZE"
            :current-page.sync="flower_page"
            :total="flower_total"
            @current-change="getFlowerList">
        </el-pagination>
        <el-button @click="backIndex">返回</el-button>  
    </div>
    <!-- 花详情 -->
    <div class="flower-detail" v-show="showFlower">
        <h2>{{add_flower_form.id==''?'新增花':'修改花'}}</h2>
        <el-form :model="add_flower_form" label-width="80px">
            <el-form-item label="门店">
                <el-select v-model="add_flower_form.shop_id" filterable placeholder="请选择门店">
                    <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="名称">
                <el-input v-model="add_flower_form.name" placeholder="请输入花名称"></el-input>
            </el-form-item>
            <el-form-item label="单位">
                <el-select v-model="add_flower_form.unit" placeholder="请选择单位">
                    <el-option v-for="item in unit_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <img class="add-icon" src="../../assets/images/icon_add.png" @click="onAddIconClick" />
            </el-form-item>
            <el-form-item label="类型">
                <el-select v-model="add_flower_form.type" placeholder="请选择类型">
                    <el-option v-for="item in type_list_for_select" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="价格">
                <el-input v-model="add_flower_form.discount_price" placeholder="请输入花价格"></el-input>
            </el-form-item>
            <el-form-item label="显示顺序">
                <el-input v-model="add_flower_form.listorder" placeholder="请输入显示顺序"></el-input>
            </el-form-item>
            <el-button @click="backToFlower">取消</el-button>
            <el-button type="primary" @click="onFlowerCommit">确认</el-button>
        </el-form>

        <!-- 添加商品单位弹窗 -->
        <div class="add-unit-pop" ref="add_unit_pop">
            <el-form>
                <el-form-item label="单位">
                    <el-input v-model="add_unit_name" placeholder="请输入商品单位"></el-input>
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>

</template>

<script>
import Vue from 'vue';
export default {
    name: 'flower-manage',
    data() {
        return {
            showIndex: 1,
            menu: [],
            loading: false,

            type_list: [],
            type_page: 1,
            type_total: 0,
            page_size: 10,
            type_oper: {
                add: false,
                edit: false,
                del: false,
            },
            type_pop_form: {
                listorder: '',
                name: ''
            },

            flower_form: {
                shop_id: '',
                type: '0',
                status: '0', // 0全部 1启用 -1禁用 
                name: '',
            },
            shop_list: [],
            type_list_for_select: [],
            flower_oper: {
                add: false,
                edit: false,
                del: false,
                update: false,
            },
            flower_list: [],
            flower_page: 1,
            flower_total: 0,
            showFlower: false,
            add_flower_form: {
                id: '',
                name: '',
                type: '',
                listorder: '',
                shop_id: '',
                discount_price: '',
                unit: '',
            },
            unit_list: [],
            add_unit_name: '',
        }
    },
    computed: {
        
    },
    watch: {
    },
    mounted: function() {
        this.getMenuOp()
    },
    methods: {
        // 获取权限
        getMenuOp() {
            let _this = this,
                menu = [];
            if(!$.isEmptyObject(this.$store.state.menunew)) {
                menu = JSON.parse(this.$store.state.menunew);
                $.each(menu, function(k, v) {
                    if(v.id == '542') {
                        menu = v.submenu;
                        $.each(menu, function(m, n) {
                            if(n.id == '1084') {
                                menu = n.submenu;
                            }
                        });
                    }
                });
            }
            menu.forEach(item => {
                if (item.id == '1085') {// 花类型
                    item.submenu.forEach(k => {
                        if (k.id == '1087') { // 新增
                            _this.type_oper.add = true
                        }
                        if (k.id == '1088') { // 修改
                            _this.type_oper.edit = true
                        }
                        if (k.id == '1089') { // 删除
                            _this.type_oper.del = true
                        }
                    })
                }
                if (item.id == '1086') { // 花列表
                    item.submenu.forEach(k => {
                        if (k.id == '1090') { // 新增
                            _this.flower_oper.add = true
                        }
                        if (k.id == '1091') { // 修改
                            _this.flower_oper.edit = true
                        }
                        if (k.id == '1092') { // 删除
                            _this.flower_oper.del = true
                        }
                        if (k.id == '1093') { // 更新状态
                            _this.flower_oper.update = true
                        }
                    })
                }
            })

            _this.menu = menu
        },

        titClk(name) {
            if(name == '花类型') {
                this.showIndex = 2
                this.type_list = []
                this.type_total = 0
                this.type_page = 1
                this.getTypeList(this.type_page)
            }else if (name == '花列表') {
                this.showIndex = 3
                this.flower_list = []
                this.flower_total = 0
                this.flower_page = 1
                this.flower_form = {
                    shop_id: '',
                    type: '0',
                    status: '0', // 0全部 1启用 -1禁用 
                    name: '',
                },
                this.getShop() // 获取门店
                this.getAllTypeList() // 获取全部花类型
                this.getUnit() // 获取全部商品单位
            }
        },

        backIndex() {
            this.showIndex = 1
        },

        /************************************ 花类型 ***********************************/
        // 获取类型列表
        getTypeList(page) {
            const _this = this;

            _this.loading = true;
            Vue.axios.post('Flower/getTypeList', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "page": page,
                        "page_size": _this.page_size,
                    }
                },
                "comment": ""
            })
            .then(res => {
                if(res.data.response.result_code == "true") {
                    if(page == 1) {
                        _this.type_total = Number(res.data.response.result.total)
                    }
                    _this.type_list = res.data.response.result.rows;
                    _this.loading = false;
                } else {
                    Vue.timeoutfun(res.data.response.result_status, _this);
                    layer.msg(res.data.response.error_msg);
                }
            })
            .catch(err => {
                layer.msg("出错啦");
            });
        },

        openTypePop() {
            let _this = this
            _this.type_pop_form = {
                listorder: '',
                name: ''
            },
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['新增花单类型', true],
                area: ['420px', 'auto'], // 宽高
                content: $(_this.$refs.type_pop), 
            }, function() {
                if (_this.type_pop_form.name == '') {
                    layer.msg("请输入类型名称")
                    return
                }
                Vue.axios.post('Flower/addType', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "listorder": _this.type_pop_form.listorder,
                            "name": _this.type_pop_form.name
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    layer.closeAll()
                    if(res.data.response.result_code == "true") {
                        layer.msg('操作成功');
                        _this.type_page = 1
                        _this.getTypeList(_this.type_page);
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            });
        },

        // 修改类型
        editType(row) {
            let _this = this
            _this.type_pop_form = {
                listorder: row.listorder,
                name: row.name
            },
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['新增花单类型', true],
                area: ['420px', 'auto'], // 宽高
                content: $(_this.$refs.type_pop), 
            }, function() {
                if (_this.type_pop_form.name == '') {
                    layer.msg("请输入类型名称")
                    return
                }
                Vue.axios.post('Flower/editType', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "listorder": _this.type_pop_form.listorder,
                            "name": _this.type_pop_form.name,
                            "id": row.id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    layer.closeAll()
                    if(res.data.response.result_code == "true") {
                        layer.msg('操作成功');
                        _this.getTypeList(_this.type_page);
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            });
        },

        // 删除类型
        delType(id) {
            let _this = this 

            layer.confirm('删除后数据将不可恢复！确认删除？', {
                btn: ['确定', '取消'],
                title: '提示',
            }, function() {
                Vue.axios.post('Flower/delType', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    layer.closeAll()
                    if(res.data.response.result_code == "true") {
                        layer.msg('操作成功');
                        _this.getTypeList(_this.type_page);
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            });
        },


        /************************************ 花列表 ***********************************/
        // 获取门店
        getShop: function() {
            const _this = this;

            Vue.axios.post('PublicData/api_getShopListByPurview', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {}
                },
                "comment": ""
            })
            .then(res => {
                if(res.data.response.result_code == "true") {
                    _this.shop_list = res.data.response.result;
                    _this.shop_list.shift();
                    _this.flower_form.shop_id = _this.shop_list[0].id
                    _this.getFlowerList(_this.flower_page)
                } else {
                    Vue.timeoutfun(res.data.response.result_status, _this);
                    layer.msg(res.data.response.error_msg);
                }
            })
            .catch(err => {
                layer.msg('出错啦');
            });
        },

        // 获取全部花类型
        getAllTypeList() {
            const _this = this;

            Vue.axios.post('Flower/getTypeList', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "page": 0,
                        "page_size": 0
                    }
                },
                "comment": ""
            })
            .then(res => {
                if(res.data.response.result_code == "true") {
                    _this.type_list_for_select = res.data.response.result.rows
                } else {
                    Vue.timeoutfun(res.data.response.result_status, _this);
                    layer.msg(res.data.response.error_msg);
                }
            })
            .catch(err => {
                layer.msg("出错啦");
            });
        },

        // 获取花列表
        getFlowerList(page) {
            const _this = this;

            _this.loading = true;
            Vue.axios.post('Flower/getDataList', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "page": page,
                        "page_size": _this.page_size,
                        "shop_id": _this.flower_form.shop_id,
                        "type": _this.flower_form.type,
                        "status": _this.flower_form.status,
                        "name": _this.flower_form.name
                    }
                },
                "comment": ""
            })
            .then(res => {
                if(res.data.response.result_code == "true") {
                    if(page == 1) {
                        _this.flower_total = Number(res.data.response.result.total)
                    }
                    _this.flower_list = res.data.response.result.rows;
                    _this.loading = false;
                } else {
                    Vue.timeoutfun(res.data.response.result_status, _this);
                    layer.msg(res.data.response.error_msg);
                }
            })
            .catch(err => {
                layer.msg("出错啦");
            });
        },

        flowerQuery() {
            this.flower_page = 1
            this.getFlowerList(this.flower_page)
        },

        // 点击“新增”花
        onAddFlowerClick() {
            this.showFlower = true
            this.add_flower_form = {
                id: '',
                name: '',
                type: '',
                listorder: '',
                shop_id: this.flower_form.shop_id,
                discount_price: '',
                unit: '',
            }
        },

        // 获取单位
        getUnit: function() {
            const _this = this;

            Vue.axios.post('PublicData/api_getGoodsUnit', {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "type":"1"
                    }
                },
                "comment": ""
            })
            .then(res => {
                if(res.data.response.result_code == "true") {
                    _this.unit_list = res.data.response.result.data;
                } else {
                    Vue.timeoutfun(res.data.response.result_status, _this);
                    layer.msg(res.data.response.error_msg);
                }
            })
            .catch(err => {
                layer.msg('出错啦');
            });
        },

        // 点击新增单位
        onAddIconClick() {
            let _this = this
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['新增商品单位', true],
                area: ['420px', 'auto'], // 宽高
                content: $(_this.$refs.add_unit_pop), 
            }, function() {
                if (_this.add_unit_name == '') {
                    layer.msg("请输入商品单位")
                    return
                }
                Vue.axios.post('merchantGoods/addGoodsUnit', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "name": _this.add_unit_name,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    layer.closeAll()
                    if(res.data.response.result_code == "true") {
                        layer.msg('添加成功');
                        _this.getUnit()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            });
        },

        // 提交花
        onFlowerCommit() {
            const _this = this;
            let url = 'Flower/addData'
            let params = {
                "name": this.add_flower_form.name,
                "type": this.add_flower_form.type,
                "listorder": this.add_flower_form.listorder,
                "shop_id": this.add_flower_form.shop_id,
                "discount_price": this.add_flower_form.discount_price,
                "unit": this.add_flower_form.unit
            }
            if (this.add_flower_form.id!='') {
                url = 'Flower/editData'
                params.id = this.add_flower_form.id
            }

            Vue.axios.post(url, {
                "header": Vue.request_header,
                "request": {
                    "param": params
                },
                "comment": ""
            })
            .then(res => {
                if(res.data.response.result_code == "true") {
                    layer.msg("操作成功")
                    _this.showFlower = false
                    if (_this.add_flower_form.id!='') {
                        _this.flower_page = 1
                    }
                    _this.getFlowerList(_this.flower_page)
                } else {
                    Vue.timeoutfun(res.data.response.result_status, _this);
                    layer.msg(res.data.response.error_msg);
                }
            })
            .catch(err => {
                layer.msg("出错啦");
            });
        },

        // 修改花
        editFlower(row) {
            this.add_flower_form = {
                id: row.id,
                name: row.name,
                type: row.type,
                listorder: row.listorder,
                shop_id: row.shop_id,
                discount_price: row.discount_price,
                unit: row.unit,
            }
            this.showFlower = true
        },

        // 更新花状态
        updateFlower(id, status) {
            let _this = this 
            let title = status == '-1' ? '是否禁用？': status == '1' ?'是否启用？' : '删除后数据将不可恢复！确认删除？'

            layer.confirm(title, {
                btn: ['确定', '取消'],
                title: '提示',
            }, function() {
                Vue.axios.post('Flower/updateDataStatus', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "id": id,
                            "status": status
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    layer.closeAll()
                    if(res.data.response.result_code == "true") {
                        layer.msg('操作成功');
                        _this.getFlowerList(_this.flower_page);
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            });
        },

        backToFlower() {
            this.showFlower = false
        },
    }
}
</script>
<style lang="less" scoped>
    .type-list {
        .red-tip {
            color: red;
        }
        .type-table {
            margin-top: 10px;
        }
        .type-pop {
            display: none;
        }
    }

    .flower-detail {
        .el-select,
        .el-input {
            width: 300px;
        }
        .add-icon {
            width: 29px;
            margin-left: 10px;
            cursor: pointer;
        }
        .add-unit-pop {
            display: none;
        }
    }
</style>